<div class="flex flex-auto">
    <p-autoComplete #carrierSearchComponent appendTo="body" [(ngModel)]="selectedCarrier" [suggestions]="carrierSuggestions" 
                        (completeMethod)="carrierSearch($event)" [placeholder]="placeholder" optionLabel="name"
                        class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto" (onSelect)="selectCarrier($event)">
        <ng-template let-carrier pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ carrier.name }} </div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>